import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { useAuth } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';

import AdminLayout from './layouts/AdminLayout';
import UserLayout from './layouts/UserLayout';

import LoginPage from './pages/LoginPage';
import TokenLoginPage from './pages/TokenLoginPage';
import RegisterPage from './pages/RegisterPage';

// Admin pages
import OverviewPage from './pages/admin/OverviewPage';
import AdminDevicesPage from './pages/admin/AdminDevicesPage';
import TokensPage from './pages/admin/TokensPage';
import UsersPage from './pages/admin/UsersPage';
import UserDetailPage from './pages/admin/UserDetailPage';
import SettingsPage from './pages/admin/SettingsPage';

// User pages
import UserDashboardPage from './pages/UserDashboardPage';
import DeviceDetailPage from './pages/DeviceDetailPage';
import ProfilePage from './pages/ProfilePage';

/** Redirect admin users landing on "/" to the admin panel */
function UserRoot() {
  const { user } = useAuth();
  if (user?.is_admin) return <Navigate to="/admin" replace />;
  return <UserDashboardPage />;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
          {/* Public */}
          <Route path="/login"    element={<LoginPage />} />
          <Route path="/register"    element={<RegisterPage />} />
          <Route path="/auth/token"  element={<TokenLoginPage />} />

          {/* Admin panel — sidebar layout */}
          <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
            <Route index                element={<OverviewPage />} />
            <Route path="devices"       element={<AdminDevicesPage />} />
            <Route path="devices/:id"   element={<DeviceDetailPage backTo="/admin/devices" />} />
            <Route path="tokens"        element={<TokensPage />} />
            <Route path="users"         element={<UsersPage />} />
            <Route path="users/:id"     element={<UserDetailPage />} />
            <Route path="settings"      element={<SettingsPage />} />
            <Route path="profile"       element={<ProfilePage />} />
          </Route>

          {/* Regular users — top-bar layout */}
          <Route path="/" element={<PrivateRoute><UserLayout /></PrivateRoute>}>
            <Route index              element={<UserRoot />} />
            <Route path="devices/:id" element={<DeviceDetailPage backTo="/" />} />
            <Route path="profile"     element={<ProfilePage />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
